import * as React from 'react';
import { List, Datagrid, TextInput, TextField, SelectInput, SelectField, DateField, NumberField, RaRecord, Identifier } from 'react-admin';
import { CardIssuers } from '../_shared/cardIssuers';
import PauseResumeAction from './components/PauseResumeAction';

export interface CreditCard extends RaRecord {
    id: Identifier;
    cardIssuer: string;
    vendorId: string;
    cardName: string;
    lastFour: string;
    cardStatus: string;
    cardType: string;
    cardLimit: number;
    spentAmount: number;
    companyId: string;
    updatedDate: string;
}

/**
 * Filter controls for the Credit Cards list: vendor (card issuer), vendor id, card name, and last four.
 */
const postFilters: JSX.Element[] = [
    <SelectInput label="Vendor" source="cardIssuer" choices={CardIssuers} emptyText="ANY" alwaysOn />,
    <TextInput label="Vendor ID" source="vendorId" alwaysOn />,
    <TextInput label="Card Name" source="cardName" alwaysOn />,
    <TextInput label="Last Four" source="lastFour" alwaysOn />,
];

const CreditCardsList = () => (
    <List
        storeKey={false}
        disableSyncWithLocation
        exporter={false}
        perPage={25}
        sort={{ field: 'updatedDate', order: 'DESC' }}
        filters={postFilters}
    >
        <Datagrid bulkActionButtons={false}>
            <SelectField source="cardIssuer" label="Vendor" choices={CardIssuers} translateChoice={false} />
            <TextField source="vendorId" label="Vendor ID" />
            <TextField source="cardName" label="Card Name" />
            <TextField source="lastFour" label="Last Four" />
            <TextField source="cardStatus" label="Status" />
            <TextField source="cardType" label="Type" />
            <NumberField source="cardLimit" label="Limit" options={{ style: 'currency', currency: 'USD' }} />
            <NumberField source="spentAmount" label="Spent" options={{ style: 'currency', currency: 'USD' }} />
            <TextField source="companyId" label="Company" />
            <DateField source="updatedDate" label="Updated" showTime />
            <PauseResumeAction label="Actions" />
        </Datagrid>
    </List>
);

export interface CreditCardsPageResource {
    name: string;
    list: React.FC;
}

/**
 * Credit Cards page - lists the unified `credit_cards` table populated from Divvy,
 * Privacy.com, and Emburse.
 */
const CreditCardsPage: CreditCardsPageResource = {
    name: 'CreditCards',
    list: CreditCardsList
};

export default CreditCardsPage;
